import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

import classNames from 'classnames';

class RoundButton extends Component {

  static Size = {
    NORMAL: 0,
    SMALL: 1
  };

  static defaultProps = {
    text: '',
    icon: 'fa-plus',
    size: RoundButton.Size.NORMAL
  };

  static propTypes = {
    icon: PropTypes.string,

    onClick: PropTypes.func.isRequired,

    text: PropTypes.string,

    size: PropTypes.number
  };

  shouldComponentUpdate(nextProps) {
    return this.props.text !== nextProps.text || this.props.icon !== this.props.icon;
  }

  onClick = (event) => {
    event.preventDefault();
    this.props.onClick(event);
  };

  render() {
    const className = classNames('btn-round', {
      'btn-round-normal': this.props.size === RoundButton.Size.NORMAL,
      'btn-round-small': this.props.size === RoundButton.Size.SMALL
    });
    return (
      <div
        className={className}
        onClick={this.onClick}
      >

        <button className="btn btn-primary">
          <i className={`fa ${this.props.icon}`} />
        </button>

        <span>{this.props.text}</span>

      </div>
    );
  }

}

export default RoundButton;
